var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('top-bar',{attrs:{"title":"All Fields","action":{ name: 'Create Field', to: { name: 'create-field' } }}}),(!_vm.isLoading)?_c('div',[(!_vm.sorted.length)?_c('empty'):_c('list',{attrs:{"fields":_vm.sorted}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }